module.exports = __webpack_public_path__ + "static/media/conestoga-logo.814bbd6b.png";